import React, { useState, useEffect } from "react";
import CustomSnackBar from "../Components/CustomSnackBar";
import {
  Box, Typography, TextField, Button, MenuItem,
  Select, FormControl, InputLabel, Card, CardContent,
  IconButton, Dialog, DialogTitle, DialogActions,
  Grid, Tooltip
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useLocation } from "react-router-dom";
import { addPermission, getPermissionForPackage, deletePermission, updatePermission } from "../utils/api";
import { Edit, Delete } from "@mui/icons-material";
import { Avatar } from "@mui/material";
import avatarPlaceholder from '../assets/avatarSample2.jpg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { getUpdatedPermission } from "../utils/utility";




export default function Collaboration({ bucketURLS={} }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [user, setUser] = useState("");
  const [inputError, setInputError] = useState("");
  const [open, setOpen] = React.useState(false);
  const [role, setRole] = React.useState('collaborator');
  const [downloadUrl, setDownloadUrl] = React.useState("");
  const [disabled, setDisabled] = React.useState(false);
  const [dialog, setDialog] = React.useState({ value: false, function: "" });
  const [message, setMessage] = React.useState("");
  // const [mode, setMode] = React.useState("add");
  const validateEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  const location = useLocation();

  const sortPermission = (permission) => {
    if (permission) {
      return [...permission].sort((a, b) => {
        if (a.permission === "owner" && b.permission !== "owner") return -1;
        if (a.permission !== "owner" && b.permission === "owner") return 1;
        return 0;
      });
    } else {
      return []
    }
  };

  const { componentName, permission } = location.state;
  const sortedPermissions = sortPermission(permission);
  const [permissionList, setPermissionList] = useState(sortedPermissions);

  useEffect(() => {
    if(bucketURLS.websearch){
      setDownloadUrl(bucketURLS.websearch)
    }
  }, [bucketURLS])

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const getUpdatedPermissionList = async (permissionData) => {
    if (permissionData && permissionData.length) {
      const updatedPermission = await getUpdatedPermission(permissionData);
      console.log('test', updatedPermission)
      return updatedPermission;

    }
  };

  const handleEdit = async () => {
    setDisabled(true);
    try {
      const responseData = await updatePermission(user.userID, componentName, role);
      if (responseData && responseData.success === 1) {
        setOpen(true);
        setDialog({ value: false, function: "" });
        setEmail("");
        setError("")
        // setMode("add");
        setDisabled(false)
        setMessage(`permission for ${user.userID} has been added as ${user.permission}`)
        const permissionData = await getPermissionForPackage(componentName);
        const updatedPermission = await getUpdatedPermissionList(permissionData);
        setPermissionList(updatedPermission)
      }
    } catch (error) {
      console.error("Error updating permission:", error);
      setOpen(true);
      setError(error.message);
      setDialog({ value: false, function: "" });
      setEmail("");
      // setMode("add");
      setDisabled(false)
    }


  }


  const handleDelete = async () => {
    try {
      const responseData = await deletePermission(user.userID, componentName);
      if (responseData && responseData.success === 1) {
        setOpen(true);
        setDialog({ value: false, function: "" });
        setError("");
        setMessage(`${user.userID} has been removed as ${user.permission}`)
        const permissionData = await getPermissionForPackage(componentName);
        const updatedPermission = await getUpdatedPermissionList(permissionData);
        setPermissionList(updatedPermission)
      }
    } catch (error) {
      console.error("Error deleting permission:", error);
      setOpen(true);
      setError(error.message);
      setDialog({ value: false, function: "" });
    }
  }




  const handleAddCollaborator = async () => {
    if (!validateEmail(email)) {
      setInputError("Please enter a valid email address.");
    } else {
      setInputError("");
      try {
        setDisabled(true)
        const responseData = await addPermission(email, componentName, role)
        if (responseData && responseData.success === 1) {
          const permissionData = await getPermissionForPackage(componentName);
          const updatedPermission = await getUpdatedPermissionList(permissionData);
          setPermissionList(updatedPermission)

        }
        setOpen(true);
        setMessage(`${email} added as ${role} successfully!`)
        setEmail("");
        setError("")
        setDisabled(false)
      } catch (error) {
        setOpen(true)
        setError(error.message);
        setDisabled(false)
      }
    }
  };

  const handleRoleChange = (e, user) => {
    setUser(user);
    setRole(e.target.value);
    setEmail(user.userID);
    setDialog({ value: true, function: "edit" })
    // setMode('edit');
  }
  return (
    <Box>
      <Dialog onClose={() => { setDialog({ value: false, function: "" }) }} open={dialog.value}>
        <DialogTitle>Are You sure you want to {dialog.function === 'delete' ? 'delete' : 'update'} {user.userID} as {dialog.function === 'delete' ? user.permission : role} ?</DialogTitle>
        <DialogActions>
          <Button onClick={() => { setDialog({ value: false, function: "" }) }} style={{ color: '#333' }}>Cancel</Button>
          <Button onClick={() => { dialog.function === 'delete' ? handleDelete() : handleEdit() }} autoFocus style={{ color: '#f05f40' }}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Card mt={2} sx={{ boxShadow: "none", paddingBottom: 0 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 600 }} gutterBottom>
            Add a collaborator to this package
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Collaborator will be given access to publish your package
          </Typography>
          <Grid container spacing={1} alignItems="center" sx={{ mt: 2 }}>
            <Grid item xs={12} md={12} lg={9}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'column', md: 'row' }, // Column on mobile/tablet, row on desktop
                  alignItems: { xs: 'stretch', sm: 'stretch', md: 'center' },
                  borderRadius: '4px',
                  overflow: 'hidden',
                  height: { sm: 'auto', md: '36px' },
                  backgroundColor: (theme) => theme.palette.grey[200],
                  gap: { sm: '8px', md: '0' },
                  padding: { sm: '8px', md: '0' },
                }}
              >
                <TextField
                  placeholder="Enter Collaborator's email"
                  value={email}
                  onChange={(e) => {
                    setInputError('');
                    setEmail(e.target.value);
                  }}
                  error={!!inputError}
                  helperText={inputError}
                  sx={{
                    flex: 1,
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                  }}
                />
                <FormControl
                  sx={{
                    marginRight: '10px',
                    borderRadius: '8px',
                    mb: { xs: '10px', sm: '0' },
                    ml: { xs: '10px', sm: '0' },
                    backgroundColor: (theme) => theme.palette.background.paper, // Ensures white background from theme
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '& .MuiSelect-select': {
                      backgroundColor: 'inherit', // Keeps background consistent
                      color: (theme) => theme.palette.text.primary, // Ensures dark text from theme
                    },
                  }}
                >
                  <Select
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Role' }}
                    sx={{
                      height: '25px',
                      minWidth: '150px', // Ensures a proper clickable area
                      color: 'inherit', // Ensures dark text color
                    }}
                  >
                    <MenuItem value="collaborator">Collaborator</MenuItem>
                    <MenuItem value="owner">Owner</MenuItem>
                  </Select>
                </FormControl>

              </Box>

            </Grid>
            <Grid item xs={12} md={12} lg={3}>
              <Button
                fullWidth
                variant="contained"
                startIcon={<AddIcon />}
                disabled={disabled}
                onClick={handleAddCollaborator}
                sx={{ height: "34px" }}
              >
                Add {role}
              </Button>
            </Grid>
          </Grid>

        </CardContent>
      </Card>
      <Card sx={{ boxShadow: "none" }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
            Owners & Collaborators
          </Typography>

          {/* List */}
          {permissionList && permissionList.length ? permissionList.map((user, index) => (
            <Card
              key={index}
              variant="outlined"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: { xs: 0, sm: 2 },
                mb: 1,
                boxShadow: "none",
                border: "none",
              }}
            >
              <Box sx={{
                display: "flex", flexDirection: { xs: "column", sm: "column", md: "row" }
                , alignItems: "center"
              }}>
                <Avatar
                  src={user.photoURL ? `${downloadUrl}/${user?.photoURL}` : avatarPlaceholder}
                  sx={{ width: 40, height: 40, mb: 1 }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = avatarPlaceholder;
                  }}
                />
                <Tooltip title={user.userID || "No email"} arrow>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: user.permission === "owner" ? "bold" : "normal",
                      ml: 1,
                      width: '100px',
                      textAlign: { xs: 'center', sm: 'center', md: 'left' },
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }

                    }
                  >
                    {user.displayName || "Anonymous"}
                  </Typography>
                </Tooltip>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                  <Select
                    value={user.permission}
                    IconComponent={(props) => <KeyboardArrowDownIcon {...props} />}
                    onChange={(e) => handleRoleChange(e, user)}
                    sx={{
                      backgroundColor: "white",
                      color: "black",
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    }}
                  >
                    <MenuItem value="owner">Owner</MenuItem>
                    <MenuItem value="collaborator">Collaborator</MenuItem>
                  </Select>
                </FormControl>

                <IconButton
                  size="small"
                  color="error"
                  sx={{ "&:hover": { backgroundColor: "error.light" } }}
                  onClick={() => {
                    setUser(user);
                    setDialog({ value: true, function: "delete" });
                  }}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Box>
            </Card>
          )) : <Typography>Not found</Typography>}




          <CustomSnackBar
            open={open}
            handleClose={handleClose}
            error={error}
            message={message}

          />
        </CardContent>


      </Card>

    </Box>
  );
}
